import { matchesQuery } from '~/utils/search-text'

type SearchableGroup = { name: string, description?: string | null }

/** Groupes dont le nom ou la description répond à la recherche (#107). */
export function filterGroups<T extends SearchableGroup>(groups: readonly T[], query: string): T[] {
  return groups.filter(group => matchesQuery(query, [group.name, group.description]))
}
